<template>
    <div>
        <v-navigation-drawer v-model="drawer" app clipped color="grey darken-4">
            <v-list dense flat>
                <v-list-item :to="{name: 'Home'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-clipboard-pulse-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.tvsmList')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-subheader>{{$vuetify.lang.t('$vuetify.tvsm.menu.history')}}</v-subheader>
                <v-list-item :to="{name: 'Log_WebRTC'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-video-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.videoCallHistory')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'Log_Reservation'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-book-open-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.videoCallReservationHistory')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider />
                <v-subheader>{{$vuetify.lang.t('$vuetify.tvsm.menu.management')}}</v-subheader>
                <v-list-item :to="{name: 'Manage_Group'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.group')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'Manage_Doctor'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-account-tie</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.user')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'Manage_User'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-bed-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.patient')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{name: 'Manage_Remote'}" color="teal accent-3">
                    <v-list-item-action>
                        <v-icon>mdi-harddisk</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.menu.device')}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app clipped-left dense>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="text-subtitle-1">T-VSM</v-toolbar-title>
            <v-spacer/>
            <v-menu offset-y>
                <template v-slot:activator="{on, attrs}">
                    <v-btn tile depressed large v-bind="attrs" v-on="on">
                        <div class="mr-4">{{$session.user.user_id}} ({{$vuetify.lang.t($code('usertype', $session.user.user_type))}})</div>
                        <v-avatar color="indigo" size="38">{{$session.user.user_name[0]}}</v-avatar>
                    </v-btn>
                </template>
                <v-card light tile>
                    <v-list dense class="py-0">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-account-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$vuetify.lang.t('$vuetify.common.menu.account')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-dialog width="240" >
                            <template v-slot:activator="{on, attrs}">
                                <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-icon>
                                        <v-icon small>mdi-web</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{$vuetify.lang.t('$vuetify.tvsm.language')}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                            <v-card light>
                                <v-list-item two-line v-for="lang in $code('langs')" :key="lang.cd" @click="changeLocale(lang.cd)">
                                    <v-list-item-content>
                                    <v-list-item-title>{{lang.on}}</v-list-item-title>
                                    <v-list-item-subtitle>{{lang.en}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="lang.cd === $vuetify.lang.current">
                                    <v-icon color="green">mdi-check-bold</v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-card>
                        </v-dialog>
                        <v-list-item @click="logoutHandler">
                            <v-list-item-icon>
                                <v-icon small>mdi-logout-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{$vuetify.lang.t('$vuetify.common.logout')}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
        </v-app-bar>

        <v-main>
            <slot/>
        </v-main>

        <v-footer app class="grey--text text--darken-2">
            <v-spacer />
            <span>&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
    </div>
</template>

<script>
export default {
    methods: {
        logoutHandler () {
            this.$session.releaseSession()
        },
        changeLocale (langCode) {
            this.$vuetify.lang.current = langCode
            this.$moment.locale(langCode)
            localStorage.setItem('locale', langCode)

            window.location.reload()
        }
    },
    data () {
        return {
            drawer: true
        }
    }
}
</script>